export default "__VITE_ASSET__CPosfqw0__"